var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoVerde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 62,
    viewBox: "0 0 56 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_22",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 0H0V62H56V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7019 36.6352L54.4352 36.2596C54.0588 36.014 53.5735 36.0117 53.1941 36.2528L53.0484 36.4219C52.7058 36.8178 52.0771 36.7622 51.8089 36.3137C51.4205 36.0267 51.0163 36.0906 50.6445 36.3618C47.2849 45.4582 38.5361 51.9442 28.2719 51.9442C18.0078 51.9442 9.00129 45.2644 5.75445 35.9561C5.47499 35.8509 5.18577 35.875 4.90556 36.0823C4.63737 36.5315 4.00783 36.5864 3.66602 36.1905L3.52028 36.0215C3.14091 35.7803 2.65561 35.7826 2.27924 36.0282L2.01256 36.4038C1.77742 36.7351 1.32443 36.8253 0.979609 36.6104L0.779781 36.4857C4.27828 48.1694 15.1126 56.6851 27.9354 56.6851C40.7582 56.6851 51.3529 48.3564 54.9723 36.8703C54.8686 36.8162 54.7762 36.7374 54.7034 36.636L54.7019 36.6352Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9339 0C13.9249 0 2.28976 10.1632 0 23.519C0.329041 23.6655 0.722687 23.5641 0.936789 23.2629L1.20348 22.8873C1.57985 22.6416 2.06514 22.6394 2.44452 22.8805L2.59026 23.0495C2.93282 23.4454 3.5616 23.3898 3.82979 22.9413C4.21292 22.6581 4.61183 22.716 4.97993 22.9789C7.32604 12.2733 16.8614 4.25864 28.2712 4.25864C39.6809 4.25864 49.4575 12.4754 51.6466 23.3838C51.9223 23.3027 52.2003 23.3447 52.4632 23.5581C52.7103 24.0193 53.3361 24.1027 53.6967 23.7241L53.8507 23.5618C54.2406 23.338 54.7252 23.3635 55.0903 23.6257L55.3397 24.0133C55.4884 24.2447 55.7423 24.3702 56.0008 24.3656C54.0656 10.5951 42.2374 0 27.9339 0Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.453 16.4575C21.6881 16.4575 16.2049 21.9414 16.2049 28.7053C16.2049 35.4693 21.6889 40.9531 28.453 40.9531C35.2171 40.9531 40.7011 35.4693 40.7011 28.7053C40.7011 21.9414 35.2171 16.4575 28.453 16.4575ZM28.4703 39.7805C22.3537 39.7805 17.3948 34.8217 17.3948 28.7053C17.3948 22.5889 22.3537 17.6302 28.4703 17.6302C34.5868 17.6302 39.5457 22.5889 39.5457 28.7053C39.5457 34.8217 34.5868 39.7805 28.4703 39.7805Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1096 31.5263V37.72H23.7638V31.5263H27.7942L22.8736 18.8428L18.122 31.4842L22.1096 31.5263Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8425 31.548V37.741H34.4967V31.548H38.527L33.6065 18.8638L28.8549 31.5052L32.8425 31.548Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3944 6.86987L19.0611 15.0994V13.4453H17.7464V16.4148L13.9707 19.7232L15.1584 21.5479L28.3944 9.20315L41.6296 21.5479L42.8181 19.7232L28.3944 6.86987Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1581 43.7988C37.274 45.4778 34.4839 45.643 32.4143 44.1992L31.8396 43.7988L31.6856 43.9288C29.7857 45.5371 27.0377 45.6535 25.0086 44.2127L24.4264 43.7988L23.7082 44.3201C21.7865 45.7151 19.1828 45.7046 17.2724 44.2954L16.5993 43.7988V42.2385L17.2724 42.7351C19.1835 44.1444 21.7865 44.1549 23.7082 42.7599L24.4264 42.2385L25.0086 42.6524C27.0377 44.094 29.7857 43.9768 31.6856 42.3685L31.8396 42.2385L32.4143 42.6389C34.4839 44.0828 37.274 43.9167 39.1581 42.2385V43.7988Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1581 47.2199C37.274 48.8989 34.4839 49.0642 32.4143 47.6203L31.8396 47.2199L31.6856 47.3499C29.7857 48.9583 27.0377 49.0747 25.0086 47.6339L24.4264 47.2199L23.7082 47.7413C21.7865 49.1363 19.1828 49.1258 17.2724 47.7165L16.5993 47.2199V45.6597L17.2724 46.1562C19.1835 47.5655 21.7865 47.576 23.7082 46.181L24.4264 45.6597L25.0086 46.0736C27.0377 47.5152 29.7857 47.398 31.6856 45.7896L31.8396 45.6597L32.4143 46.0601C34.4839 47.5039 37.274 47.3379 39.1581 45.6597V47.2199Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37562 35.024L9.47607 30.3146L18.1934 28.3945L17.6209 29.6153L18.4165 29.4875L17.2393 32.2242L15.2981 32.7966L16.1575 31.3964L7.37562 35.024Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5456 27.3564L27.2135 29.0745L28.6934 28.8514L28.0248 30.0285L29.0435 29.8377L29.9975 27.8019L29.3612 27.8973L29.9975 26.6248L26.5456 27.3564Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8616 26.3061L37.3063 27.2286L47.2429 24.365L36.8616 26.3061Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6654 30.5693L43.6475 30.0284L41.8655 30.6647L40.5291 29.1375L39.8928 29.6783L40.8574 30.8172L38.4669 31.5639L38.4745 31.5827H38.4091L34.7543 32.7786V33.8994L41.4516 31.7096L43.2974 34.5462L44.4746 34.0692L42.4703 31.4925L44.6654 30.5693Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7685 37.9838V36.9238L13.3577 39.4141L14.1848 40.4004L22.1975 37.9838H21.7685Z",
    fill: "#6AAE3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1251 36.048V37.2349L32.4954 34.4704V33.3391L24.1251 36.048Z",
    fill: "#6AAE3B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVerde);
export default __webpack_public_path__ + "static/media/logoVerde.8bb18e424caa4c4807848283afc9a45b.svg";
export { ForwardRef as ReactComponent };